import { render, staticRenderFns } from "./examinations.vue?vue&type=template&id=16a4782d&scoped=true&"
import script from "./examinations.vue?vue&type=script&lang=js&"
export * from "./examinations.vue?vue&type=script&lang=js&"
import style0 from "./examinations.vue?vue&type=style&index=0&id=16a4782d&prod&lang=scss&"
import style1 from "./examinations.vue?vue&type=style&index=1&id=16a4782d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a4782d",
  null
  
)

export default component.exports